// RIA Broker
const prdRia =
    "//assets.adobedtm.com/a79b0dc1801d/7ce6d92c8ad8/launch-bbe49deaf46d.min.js";
const devRia =
    "//assets.adobedtm.com/a79b0dc1801d/7ce6d92c8ad8/launch-3a4e2dedfc65-development.min.js";

// Annuities Financial Professional
const prdAnnFp =
    "//assets.adobedtm.com/a79b0dc1801d/5f57ca8e2ac5/launch-a311e61a7b12.min.js";
const devAnnFp =
    "//assets.adobedtm.com/a79b0dc1801d/5f57ca8e2ac5/launch-4af7d7775621-development.min.js";

const getSiteUrl = () => {
    const hst = document.location.hostname;
    const prod = hst.indexOf("-ams.") === -1;

    if (hst.indexOf("ria.") > -1) {
        if (prod) {
            return prdRia;
        } else {
            return devRia;
        }
    } else if (
        hst.indexOf("annuities.") > -1 &&
        hst.indexOf("myaccount-.") === -1
    ) {
        if (prod) {
            return prdAnnFp;
        } else {
            return devAnnFp;
        }
    }
};

export const appendAnalytics = () => {
    const script = document.createElement("script");
    script.src = getSiteUrl();
    script.async = true;
    document.body.appendChild(script);
};
